module.exports = __webpack_public_path__ + "static/media/1_1.8c0c36c9.png";